var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2867B2",
  d: "M22.5 0A1.5 1.5 0 0 1 24 1.5v21a1.5 1.5 0 0 1-1.5 1.5h-21A1.5 1.5 0 0 1 0 22.5v-21A1.5 1.5 0 0 1 1.5 0h21zM8 8H5v11h3V8zm12 4.241c0-5.253-5.604-5.062-7-2.476V8h-3v11h3v-5.604c0-3.113 4-3.368 4 0V19h3zM6.5 3.204c-.966 0-1.75.79-1.75 1.764s.784 1.764 1.75 1.764c.967 0 1.75-.79 1.75-1.764S7.466 3.204 6.5 3.204z"
})));
export default SvgLinkedin;